import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";

import ScreenLoader from "./components/ScreenLoader";

const Home = lazy(() => import("./containers/Home"));
const RebateCenter = lazy(() => import("./containers/RebateCenter"));
const ItemCategory = lazy(() => import("./containers/ItemCategory"));
const ItemDetail = lazy(() => import("./containers/ItemDetail"));
const SingleSignOn = lazy(() => import("./containers/SingleSignOn"));
const Error = lazy(() => import("./containers/Error"));
const NotFound = lazy(() => import("./containers/NotFound"));

export default function Routes() {
	const render = () => {
		return (
			<Suspense fallback={<ScreenLoader></ScreenLoader>}>
				<Switch>
					{/* Public routes regardless or rather user is authenticated or not */}
					<Route exact path="/">
						<Home />
					</Route>
					<Route exact path="/rebate-center">
						<RebateCenter />
					</Route>
					<Route exact path="/category/:categoryId">
						<ItemCategory />
					</Route>
					<Route exact path="/category/:categoryId/:educationId">
						<ItemCategory />
					</Route>
					<Route exact path="/item/:itemId">
						<ItemDetail />
					</Route>
					<Route exact path="/sso/:uuid/:token">
						<Helmet>
							<title>Single Sign On</title>
						</Helmet>
						<SingleSignOn />
					</Route>
					<Route exact path="/error">
						<Helmet>
							<title>Error</title>
						</Helmet>
						<Error />
					</Route>

					{/* Finally, catch all unmatched routes */}
					<Route>
						<Helmet>
							<title>Not Found</title>
						</Helmet>
						<NotFound />
					</Route>
				</Switch>
			</Suspense>
		);
	};

	return render();
}
